<template>
    <div class="container remove-padding-margin">
        <div class="fixed-judul fixed-top">
            <div class="row justify-content-center align-items-center set-row" style="border-bottom: 1px solid #F2F5F7;">
                <div class="col-md-3 col-sm-3 col-3 remove-padding" data-toggle="modal" data-target="#modal">
                    <img src="../../../assets/img/x2.svg">
                </div>
                <div class="col-md-7 col-sm-7 col-7 text-center remove-padding">
                    <h6 class="remove-margin font-16 font-colorcheck text-promo">Tambah Workshop</h6>
                </div>
                <div class="col-md-2 col-sm-2 col-2"></div>
            </div>
        </div>
        <main class="add-padding-default">
            <div class="flex-100">
                <div class="flex-1 pad-top-50">
                    <div class="animasi-card  bg-transparent d-flex mar-top-16 mar-bottom-16">
                        <div class="font-16 status-login color-206CF"><span class="font-weight-bold color-206CF">Langkah 1/2</span></div>
                    </div>
                    <div class="text-outlets mar-bottom-16">
                        <div class="color-0000">Masukkan data workshop sebagai tempat pengerjaan proses produksi</div>
                    </div>
                    <form action="">
                        <div class="form-group">
                            <label class="remove-margin require" for="namaCPOworkshop">Nama Workshop</label>
                            <input type="text" class="form-control inputs" id="namaCPOworkshop" aria-describedby="emailHelp" placeholder="Clean Laundry" v-model="dataDataWorkshop.nama" v-on:keyup="inputnamacreateworkshoplist">
	                        <ErrorMessage class="error" label="Nama Workshop" :validation="$v.dataDataWorkshop.nama"></ErrorMessage>
	                        
	                        <label class="remove-margin mar-top-12 require" for="phone">Nomor Telpon Workshop</label>
                            <div class="input-group remove-padding">
                                <vue-country-code
                                    @onSelect="onSelect" :preferredCountries="['id', 'my', 'bn']">
                                </vue-country-code>
                                <input type="tel" class="form-control inputs" id="phone" placeholder="81757875431" v-model="dataDataWorkshop.telp" v-on:keyup="nomorWaOnkeyup">
                            </div>
	                        <ErrorMessage class="error" label="Nomor Telepon" :validation="$v.dataDataWorkshop.telp"></ErrorMessage>
	                        
                            <div class="mod">
                                <label class="remove-margin mar-top-12 require">Kota</label>
                                <Select2 class="" id="select2" v-on:change="cekValidate" v-model="dataDataWorkshop.selectedkota" :options="dataDataWorkshop.optionskota"
                                         :settings="{ placeholder: 'Pilih Kota' }"
                                         @change="myChangeEvent($event)"/>
                            </div>
	                        <ErrorMessage class="error" label="Kota" :validation="$v.dataDataWorkshop.selectedkota"></ErrorMessage>

                            <label class="remove-margin mar-top-12 require" for="alamat">Alamat Lengkap</label>
                            <textarea type="text" class="form-control inputs" id="alamat" aria-describedby="emailHelp"
                                      placeholder="Jln. Jendral Bersih Selalu No. 1" v-on:keyup="inputalamatcreateworkshoplist" v-model="dataDataWorkshop.Alamat"></textarea>
	                        <ErrorMessage class="error" label="Alamat" :validation="$v.dataDataWorkshop.Alamat"></ErrorMessage>
                        </div>
                    </form>
                </div>
                <div class="button-lanjut ">
                <button class="btn btn-login btn-long remove-margin" id="BtnCreateWorkshoplist" @click="cekconnection">
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                          v-if="isClicked === true"></span><span id="textBtnCreateWorkshoplist">Lanjut</span>
                </button>
            </div>
                <div class="modal fade" id="modal" role="dialog">
                    <div class="modal-dialog modal-lg  bani-modal">
                        <div class="modal-content">
                            <div class="modal-header">
                                <div class="nav-btn kiri"></div>
                                <div class="navbar-title text-center">Batal Membuat Workshop</div>
                                <div class="nav-btn kanan tutup">
                                    <img src="../../../assets/img/x2.svg" data-dismiss="modal" alt="">
                                </div>
                            </div>
                            <div class="modal-body">
                                <div>Apakah anda yakin ingin membatalkan pembuatan workshop baru? </div>
                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-outline-primary btn-long" data-dismiss="modal"
                                        @click="gohome">Ya, Batalkan
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    </div>
</template>

<script>
    import Select2 from 'v-select2-component';
    import ErrorMessage from "@/component-items/ErrorMessage";
    import {required, minLength, maxLength} from 'vuelidate/lib/validators'
    export default {
        name: "DataWorkshop",
        components: {Select2, ErrorMessage},
        props:["dataDataWorkshop"],
        data(){
          return{
            telpCode: '',
              isClicked:false,
	          requestHeaders: {
		          headers: {
			          'Authorization': 'Bearer ' + localStorage.getItem('token'),
		          }
	          },
          }
        },
	    validations: {
		    dataDataWorkshop: {
		    	nama: {
		    		required,
				    minLength: minLength(2)
			    },
			    telp: {
		    		required,
				    minLength: minLength(8),
				    maxLength: maxLength(12),
			    },
			    selectedkota: {
		    		required,
			    },
			    Alamat: {
		    		required,
				    minLength: minLength(2)
			    },
          telp_code: {
            required
          }
		    }
	    },
        mounted(){
          this.getkota();
          this.cekValidate();

        },
        methods:{
            back(){
                this.$emit('backtolist')
            },
            onSelect({name, iso2, dialCode}) {
              this.telpCode=dialCode;
              this.dataDataWorkshop.telp_code= dialCode;
            },
            next() {
                this.$emit("showProductionWorkshop")
            },
            gohome() {
                this.$emit('backtolist', 'workshop')
            },

            inputnamacreateworkshoplist(event){
                var handleevent = event.target.value;
                var handle = handleevent.replace(/[^0-9A-Za-z.,' -]+/,'');
                this.dataDataWorkshop.nama = handle;
                this.cekValidate()
            },

            inputalamatcreateworkshoplist(event){
                var handleevent = event.target.value;
                var handle = handleevent.replace(/[^0-9A-Za-z.,' -]+/,'');
                this.dataDataWorkshop.Alamat = handle;
                this.cekValidate()
            },

            nomorWaOnkeyup(event) {
                var phoneField = event.target.value;
                var frstCar = phoneField.substring(0,1);
                var firstTel = phoneField.substring(1,15);
                var secCar = phoneField.substring(0,2);
                var secTel = phoneField.substring(2,15);
                var thrdcar = phoneField.substring(0,12);
                var output

                if(frstCar == 0){
                    output = firstTel
                }else if(secCar == this.telpCode){
                    output = secTel
                }else{
                    output = thrdcar
                }
                var number = output.replace(/[^0-9]+/, '');

                var charLenght = number.length;
                if (charLenght >= 8 && charLenght <= 12) {
                    // $('#BtnCreateWorkshoplist').prop('disabled', false);
                } else {
                    // $('#BtnCreateWorkshoplist').prop('disabled', true);
                }
                this.dataDataWorkshop.telp = number;
                this.cekValidate()
            },
            async getkota() {
                try {
                    const response = await this.$axios.get(this.$baseurl + '/masterData/meta/kota_meta', this.requestHeaders)
                    if (response.status === 200) {
                        var rawkota = response.data.data;
                        this.dataDataWorkshop.optionskota.push({id: "", text: "Pilih Kota"})
                        for (var i = 0; i < rawkota.length; i++) {
                            this.dataDataWorkshop.optionskota.push({id: rawkota[i].id, text: rawkota[i].nama})
                        }
                    }
                } catch (e) {
                	this.$catch_error_response(e)
	                $('#loadingPage').hide();
	                $('#loadingPage').removeClass('overlayLoading');
                }

            },
            myChangeEvent(val) {
                this.myValue = val
            },
            cekValidate() {
            	return
                var kota = this.dataDataWorkshop.selectedkota;
                var namaOutlet = this.dataDataWorkshop.nama;
                var telp = this.dataDataWorkshop.telp;
                var alamat= this.dataDataWorkshop.Alamat;
                var lenPass = namaOutlet.length;
                if (lenPass >= 2 && kota !== '1' && (telp.length >= 8 && telp.length <= 12) && alamat.length>=2) {
                    $('#BtnCreateWorkshoplist').prop('disabled', false);
                } else {
                    $('#BtnCreateWorkshoplist').prop('disabled', true);
                }
            },

            async cekconnection(){
	            if (this.$v.dataDataWorkshop.$invalid) {
		            this.$v.dataDataWorkshop.$touch()
		            this.$toast.error("Mohon Lengkapi Data Terlebih Dahulu")
		            return
	            }
                this.isClicked = true;
                $('#textBtnCreateWorkshoplist').hide();
                $('#BtnCreateWorkshoplist').prop('disabled', true);
                try {
                    const response = await this.$axios.get(this.$baseurl + '/masterData/meta/cek_koneksi',this.requestHeaders);
                    if (response.status === 200) {
                        if (response.data.status === true) {
                            this.cekuniqeworkshop();
                            this.isClicked = false;
                            $('#textBtnCreateWorkshoplist').show();
                            $('#BtnCreateWorkshoplist').prop('disabled', false);
                        } else {
                            this.isClicked = false;
                            $('#textBtnCreateWorkshoplist').show();
                            $('#BtnCreateWorkshoplist').prop('disabled', false);
                            this.$toast.error(response.data.msg)
                        }
                    }
                }  catch (e) {
                	this.$catch_error_response(e)
	                this.isClicked = false;
	                $('#textBtnCreateWorkshoplist').show();
	                $('#BtnCreateWorkshoplist').prop('disabled', false);
                }
            },

            async cekuniqeworkshop(){
                this.isClicked = true;
                $('#textBtnCreateWorkshoplist').hide();
                $('#BtnCreateWorkshoplist').prop('disabled', true);
                try {
                    const checkname = new FormData
                    checkname.append('nama_workshop',this.dataDataWorkshop.nama);
                    const response = await this.$axios.post(this.$baseurl + '/masterData/outlet/cek_nama_workshop_tersedia', checkname, this.requestHeaders);
                    if (response.status === 200) {
                        if (response.data.status === true) {
                            this.next();
                            this.isClicked = false;
                            $('#textBtnCreateWorkshoplist').show();
                            $('#BtnCreateWorkshoplist').prop('disabled', false);
                        } else {
                        	this.$toast.error(response.data.msg)
                            this.isClicked = false;
                            $('#textBtnCreateWorkshoplist').show();
                            $('#BtnCreateWorkshoplist').prop('disabled', false);
                        }
                    }
                }  catch (e) {
                	this.$catch_error_response(e)
	                this.isClicked = false;
	                $('#textBtnCreateWorkshoplist').show();
	                $('#BtnCreateWorkshoplist').prop('disabled', false);
                }
            },

        }
    }
</script>

<style scoped>

</style>